/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'

class Filter extends React.Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {}

  filter() {
    var queryParams = []
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    var pageNumber = sessionStorage.getItem('pageNumber')
    var pageSize = sessionStorage.getItem('dropDownVal')
    let {typeVariable, title, valueVariable, urlFilter} = this.props
    if (typeVariable && document.getElementById('typeVariable').value !== '') {
      queryParams.push(`type=${document.getElementById('typeVariable').value}`)
    }
    if (title && document.getElementById('title').value !== '') {
      queryParams.push(`title=${document.getElementById('title').value.trim()}`)
    }
    if (valueVariable && document.getElementById('value').value !== '') {
      queryParams.push(`value=${document.getElementById('value').value.trim()}`)
    }
    if (this.props.forceFilter && queryParams.length === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      sessionStorage.setItem('params', queryParams.join('&'))
      http
        .get(
          `${urlFilter}?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${sessionStorage.getItem('params')}`,
          {}
        )
        .then((response) => {
          if (response.data.error === null) {
            this.props.filter(response.data.object.result, response.data.object.countAll)
          } else {
            this.props.filter([])
          }
        })
    }
  }

  render() {
    let {typeVariable, title, valueVariable} = this.props
    return (
      <div className="filterComponent">
        <div className="filterInputs">
          {typeVariable ? (
            <div className="formComponent">
              <label>نوع</label>
              <select className="form-control" aria-label="Small" id="typeVariable">
                <option value="">------</option>
                <option value="boolean">boolian</option>
                <option value="character">character</option>
                <option value="integer">integer</option>
                <option value="long">long</option>
                <option value="timestamp">timestamp</option>
                <option value="decimal">decimal</option>
                <option value="double">double</option>
                <option value="date">date</option>
                <option value="string">string</option>
                <option value="custom">custom</option>
                <option value="object">object</option>
              </select>
            </div>
          ) : (
            ''
          )}
          {title ? (
            <div className="formComponent">
              <label>عنوان</label>
              <input className="form-control" id="title" type="text" />
            </div>
          ) : (
            ''
          )}
          {valueVariable ? (
            <div className="formComponent">
              <label>مقدار</label>
              <input className="form-control" id="value" type="text" />
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="filterOption">
          <button className="confirmFilter" onClick={this.filter.bind(this)}>
            جست و جو
          </button>
        </div>
      </div>
    )
  }
}
export default Filter
